module.exports = __webpack_public_path__ + "media/images/icons/chart-up-c568eccdadb8d9ba4f245ab21118c334.svg";